import { render, staticRenderFns } from "./UsertypePermission.vue?vue&type=template&id=2b078715&"
import script from "./UsertypePermission.vue?vue&type=script&lang=js&"
export * from "./UsertypePermission.vue?vue&type=script&lang=js&"
import style0 from "./UsertypePermission.vue?vue&type=style&index=0&id=2b078715&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports